import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

type Props = {
  imageUrl: string;
  url?: string;
};

export const SideMenuHeader: React.FC<Props> = ({ imageUrl, url }) =>
  url ? (
    <div className={styles.SideMenuHeader}>
      <Link to={url}>
        <img src={imageUrl} alt='logo' />
      </Link>
    </div>
  ) : (
    <div className={styles.SideMenuHeader}>
      <img src={imageUrl} alt='logo' />
    </div>
  );
